module.exports = __webpack_public_path__ + "img/sv86.d802a7bc.svg";